<template>
  <KeyRoad />
</template>
<script>
import KeyRoad from '../components/index.vue'

export default {
  name: 'national-road',
  components: {
    KeyRoad,
  },
  provide: {
    pRoadType: 'NATIONAL_HIGHWAY',
  },
}
</script>
